var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendarDay02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2zM9 5h6v2h2V5h3v14H4V5h3v2h2zm.785 11h4.465v-1.143h-2.518l.826-.953q.66-.66.954-1.05.298-.396.44-.752.14-.36.14-.738 0-.896-.563-1.376-.558-.479-1.595-.479-.645 0-1.169.282a2.06 2.06 0 0 0-.817.782 2.1 2.1 0 0 0-.295 1.085h1.486q0-.43.21-.716a.65.65 0 0 1 .55-.29q.342 0 .523.215.18.215.18.629 0 .51-.76 1.375l-2.057 2.162z",
  clipRule: "evenodd"
})));
export default SvgCalendarDay02;